export const FLAG_GETTING_PREVENTIVE_TASKS = 'FLAG_GETTING_PREVENTIVE_TASKS';
export const GET_PREVENTIVE_TASKS = 'GET_PREVENTIVE_TASKS';
export const CLEAR_PREVENTIVE_TASKS = 'CLEAR_PREVENTIVE_TASKS';
export const GET_PREVENTIVE_TASK = 'GET_PREVENTIVE_TASK';
export const CLEAR_PREVENTIVE_TASK = 'CLEAR_PREVENTIVE_TASK';
export const FLAG_PREVENTIVE_TASK_ACTIVITY = 'FLAG_PREVENTIVE_TASK_ACTIVITY';
export const FLAG_PREVENTIVE_TASK_HAS_RESOURCE =
  'FLAG_PREVENTIVE_TASK_HAS_RESOURCE';
export const FLAG_GETTING_PREVENTIVE_TASK_RESOURCE =
  'FLAG_GETTING_PREVENTIVE_TASK_RESOURCE';
export const GET_PREVENTIVE_TASK_RESOURCE = 'GET_PREVENTIVE_TASK_RESOURCE';
export const CLEAR_PREVENTIVE_TASK_RESOURCE = 'CLEAR_PREVENTIVE_TASK_RESOURCE';
